import { Control, Controller, FieldErrors } from "react-hook-form";
import { Select } from "@jugl-web/ui-components/cross-platform/forms/Select";
import { useTranslations } from "@jugl-web/utils";
import { useInventoryFormOptions } from "@jugl-web/domain-resources/inventory/hooks/useInventoryFormOptions";
import { ServiceFormValues } from "../../types";

interface ComponentProps {
  control: Control<ServiceFormValues>;
  errors?: FieldErrors<ServiceFormValues>;
}

export const UnitField = ({ control, errors }: ComponentProps) => {
  const { t } = useTranslations();
  const { units } = useInventoryFormOptions();

  return (
    <div className="w-full">
      <Controller
        control={control}
        name="unit"
        rules={{
          required: {
            value: true,
            message: t({
              id: "inventory-item-form-page.mandatory-field",
              defaultMessage: "Mandatory field",
            }),
          },
        }}
        render={({ field: { value, onChange } }) => (
          <Select
            isRequired
            isInvalid={!!errors?.unit}
            errorMessage={errors?.unit?.message}
            items={units.map((unit) => ({
              name: unit.value,
              value: unit.id,
              triggerClassName:
                "px-2 py-0 h-[38px] flex items-center leading-[22px]",
            }))}
            placeholder={t({
              id: "common.select",
              defaultMessage: "Select",
            })}
            label={t({
              id: "inventory-item-form-page.unit",
              defaultMessage: "Unit",
            })}
            onSelect={onChange}
            value={value || undefined}
          />
        )}
      />
    </div>
  );
};
